module.exports = __webpack_public_path__ + "static/debtInfo-479b27a672b1d4012b2fc9b39f57d775.svg";